// La Clica food-vendor secondary: taquero tongs.
// Silhouette = long-handled scissor tongs over a paper gorra (cap).
// Universal taco-stand signature — the cap + tongs together = "el taquero."

interface TaqueroTongsProps {
  /** Tong/cap color (typically chrome or white). */
  bodyColor?: string;
  /** Handle grip + apron strap accent. */
  accentColor?: string;
  /** Rendered size in px (square bounding box). */
  size?: number;
  /** Optional className for positioning. */
  className?: string;
}

export function TaqueroTongs({
  bodyColor = '#f5ecd6',     // bone (paper cap + chrome tongs)
  accentColor = '#e6342a',    // aerosol red (apron strap)
  size = 48,
  className,
}: TaqueroTongsProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      {/* Paper gorra cap — folded boat-shape */}
      <path
        d="M6 14 L24 6 L42 14 L42 18 L24 22 L6 18 Z"
        fill={bodyColor}
      />
      {/* Cap fold line */}
      <line x1="6" y1="14" x2="42" y2="14" stroke="rgba(0,0,0,0.2)" strokeWidth="0.6" />
      {/* Cap red band */}
      <rect x="6" y="16" width="36" height="2" fill={accentColor} />
      {/* Tongs — scissor handles open, hinged at center */}
      {/* Left arm */}
      <path
        d="M16 26 L14 42 L18 42 L20 30 Z"
        fill={bodyColor}
      />
      {/* Right arm */}
      <path
        d="M32 26 L30 30 L28 42 L34 42 Z"
        fill={bodyColor}
      />
      {/* Hinge pin */}
      <circle cx="24" cy="26" r="2" fill={accentColor} />
      {/* Tong tips — top */}
      <path d="M16 26 L20 22 L22 24 L20 28 Z" fill={bodyColor} />
      <path d="M32 26 L28 22 L26 24 L28 28 Z" fill={bodyColor} />
      {/* Handle grip wraps — red strips */}
      <rect x="13" y="38" width="6" height="2" fill={accentColor} />
      <rect x="29" y="38" width="6" height="2" fill={accentColor} />
    </svg>
  );
}
